var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M281.001 266.006v-181c0-24.813-20.187-45-45-45H45c-24.813 0-45 20.187-45 45v181c0 24.813 20.187 45 45 45h22.501l25.5 33.999c6.002 8.003 18.011 7.986 24 0l25.5-33.999h93.5c24.813 0 45-20.187 45-45zm-78.399-29.011c-5.856 5.857-15.355 5.859-21.213 0l-5.559-5.559c-10.278 6.552-22.462 10.366-35.528 10.366-36.556 0-66.297-29.74-66.297-66.296 0-36.557 29.741-66.297 66.297-66.297 36.557 0 66.297 29.741 66.297 66.297a65.89 65.89 0 0 1-9.733 34.541l5.735 5.735c5.859 5.858 5.859 15.355.001 21.213z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.303 139.209c-20.014 0-36.297 16.283-36.297 36.297 0 25.612 25.924 43.156 49.639 33.745l-5.077-5.077c-5.858-5.857-5.858-15.355 0-21.213 5.857-5.858 15.355-5.858 21.213 0l4.714 4.714c8.415-23.572-9.166-48.466-34.192-48.466zM362.358 307.111h18.441l-9.178-24.321z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 161H311.001v105.006c0 41.355-33.645 75-75 75h-5.002V387c0 24.813 20.187 45 45 45h93.498l25.5 33.999c6.003 8.003 18.011 7.985 24 0l25.5-33.999H467c24.813 0 45-20.187 45-45V206c0-24.813-20.187-45-45-45zm-49.704 200.337c-7.722 2.914-16.394-.957-19.33-8.737l-5.845-15.489h-41.189l-5.915 15.531c-2.948 7.742-11.616 11.628-19.356 8.679-7.742-2.948-11.627-11.615-8.679-19.356l38.523-101.149c2.442-6.449 8.725-11.099 16.152-11.107a17.264 17.264 0 0 1 16.04 10.735c.131.319-1.583-4.212 38.335 101.562 2.926 7.752-.986 16.406-8.736 19.331z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.cb52b8eca25330a45fc007fb19a137a2.svg";
export { ForwardRef as ReactComponent };